import React from 'react';

import { Button, Icon, Space, Typography } from '@sravni/react-design-system';
import { Check } from '@sravni/react-icons';
import { useBoolean } from '@sravni/react-utils';

import { ReviewType } from '../../helpers/reviews';
import { ActionDialog } from '../UserActions/Dialog';

import styles from './problem-solved.module.scss';

interface IProps {
  isMobile?: boolean;
  onSolved?: () => void;
  reviewTypes?: ReviewType;
  showProblemSolveBlock?: boolean;
}

export const ProblemSolved: React.FC<IProps> = ({ onSolved, reviewTypes, isMobile, showProblemSolveBlock }) => {
  const [showSolveDialog, setShowSolveDialog] = useBoolean(false);
  const [showThankMessage, setShowThankMessage] = useBoolean(false);

  const handleSolvedClick = () => {
    onSolved();
    setShowSolveDialog.off();
    setShowThankMessage.on();
  };

  if (showThankMessage) {
    return (
      <div className={styles.wrapper}>
        <Typography.Text size={16} strong>
          Спасибо за обратную связь!
        </Typography.Text>
      </div>
    );
  }

  let decisionWord = '';
  switch (reviewTypes?.namesType.gender) {
    case 'masculine':
      decisionWord = 'решил';
      break;
    case 'feminine':
      decisionWord = 'решила';
      break;
    case 'neuter':
      decisionWord = 'решило';
      break;
    default:
      decisionWord = 'решил';
  }

  if (showProblemSolveBlock) {
    return (
      <div className={styles.wrapper}>
        <Space
          direction={isMobile ? 'vertical' : 'horizontal'}
          justify={'space-between'}
          align={isMobile ? 'start' : 'center'}
          size={isMobile ? 24 : 12}
        >
          <Typography.Text size={16} strong>
            Вам помог ответ?
          </Typography.Text>
          <Button size={36} variant={'outlined'} block={isMobile} onClick={() => setShowSolveDialog.on()}>
            Проблема решена
            <Icon size={24} icon={<Check />} />
          </Button>
          {showSolveDialog && onSolved && (
            <ActionDialog
              title={`${reviewTypes?.namesType.bigFirstChar} полностью ${decisionWord} вашу проблему?`}
              showDialog={showSolveDialog}
              onClose={() => setShowSolveDialog.off()}
              onConfirm={handleSolvedClick}
              confirmText={'Да'}
              cancelText={'Нет'}
            />
          )}
        </Space>
      </div>
    );
  }

  return null;
};
